import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'
import { useUnit } from 'effector-react'
import { $isBuyKeysModalVisible } from '@/entities/navigation/store'
import { changeBuyKeysModalVisible } from '@/entities/navigation/events'
import { BuyKeysModalWindow } from '.'

export const GlobalBuyKeysModal = () => {
  const isBuyModalVisible = useUnit($isBuyKeysModalVisible)
  const [show, setShow] = useState(false)
  const [animate, setAnimate] = useState(false)

  useEffect(() => {
    if (isBuyModalVisible) {
      setShow(true)
      requestAnimationFrame(() => setAnimate(true))
    } else {
      setAnimate(false)
      const timeoutId = setTimeout(() => setShow(false), 300)
      return () => clearTimeout(timeoutId)
    }
  }, [isBuyModalVisible])

  if (!show) return null
  return ReactDOM.createPortal(
    <BuyKeysModalWindow
      isOpen={animate}
      onClose={() => changeBuyKeysModalVisible(false)}
    />,
    document.body
  )
}
